import { 
  GET_USERS, 
  GET_USERS_MINIMAL,
  USERS_LOADING, 
  UPDATE_USER, 
  GET_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  DELETE_USER
} from '../actions/types';

const initialState = {
  users: [],
  usersMinimal: [],
  pagination: null,
  loading: false,
  selectedUser: null,
  updateSuccess: false,
  updateError: null
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_USERS:
      return {
        ...state,
        users: action.payload.data || action.payload,
        pagination: action.payload.pagination || null,
        loading: false
      };
    case GET_USERS_MINIMAL:
      return {
        ...state,
        usersMinimal: action.payload,
        loading: false
      };
    case USERS_LOADING:
      return {
        ...state,
        loading: true
      };
    case UPDATE_USER:
      return {
        ...state,
        loading: true,
        updateSuccess: false,
        updateError: null
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        users: state.users.map(user => 
          user._id === action.payload._id ? action.payload : user
        ),
        selectedUser: action.payload,
        loading: false,
        updateSuccess: true,
        updateError: null
      };
    case UPDATE_USER_FAIL:
      return {
        ...state,
        loading: false,
        updateSuccess: false,
        updateError: action.payload
      };
    case GET_USER:
      return {
        ...state,
        selectedUser: action.payload
      };
    case DELETE_USER:
      const updatedUsers = state.users.filter(user => user._id !== action.payload);
      return {
        ...state,
        users: updatedUsers,
        // Update pagination total if it exists
        pagination: state.pagination ? {
          ...state.pagination,
          total: state.pagination.total - 1
        } : null
      };
    default:
      return state;
  }
} 
